import { render, staticRenderFns } from "./Weekly.vue?vue&type=template&id=ccdaad2a"
import script from "./Weekly.vue?vue&type=script&lang=ts"
export * from "./Weekly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports